import dayjs from 'dayjs'
import { TimeRangePickerProps } from 'antd'
import { rangePresets } from '../../../../billing/transactions/list/consts'

export const TRANSACTIONS_PAGE_SIZE = 100

export const transactionsRangePresets: TimeRangePickerProps['presets'] = [
  ...(rangePresets ?? []),
  { label: 'From 01.06.2025', value: [dayjs('2025-06-01'), dayjs()] },
]

export const transactionDetailsType = [
  { value: 'Budget payment', label: 'Budget payment' },
  { value: 'Incoming int transfer', label: 'Incoming int transfer' },
  { value: 'Outgoing int transfer', label: 'Outgoing int transfer' },
  { value: 'lp_dividend', label: 'LP Dividend' },
  { value: 'dividend', label: 'Dividend' },
  { value: 'lp_investment', label: 'LP Investment' },
  { value: 'investment', label: 'Investment' },
  { value: 'earning', label: 'Earning' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'Other payment', label: 'Other payment' },
  { value: 'Commissions', label: 'Commissions' },
] as const

export const transactionTableColumns = [
  {
    key: 'id',
    label: 'ID CRM',
    sorter: false,
  },
  {
    key: 'type',
    label: 'Type',
    sorter: false,
  },
  {
    key: 'walletName',
    label: 'Wallet',
    sorter: false,
  },
  {
    key: 'datetime',
    label: 'Date Time',
  },
  {
    key: 'amount',
    label: 'Amount',
    sorter: false,
  },
  {
    key: 'ourCommission',
    label: 'Our commission',
    sorter: false,
  },
  {
    key: 'psCommission',
    label: 'PS Commission',
    sorter: false,
  },
  {
    key: 'clientAmount',
    label: 'Client Amount',
    sorter: false,
  },
  {
    key: 'exchangeRate',
    label: 'Exchange Rate',
    sorter: false,
  },
  {
    key: 'amountUsd',
    label: 'Amount, USD',
    render: (item: string) => parseFloat(item).toString(),
  },
  {
    key: 'comment',
    label: 'Comment',
    sorter: false,
  },
  {
    key: 'action',
    label: 'Action',
    sorter: false,
  },
]
